import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ProjectPDFLink,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateThreePDFSectionWithSubsections } from "./common";
import { ResumePDFIcon } from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeProject } from "lib/redux/types";

export const Project = ({
  heading,
  projects,
  isPDF,
  themeColor,
}: {
  heading: string;
  projects: ResumeProject[];
  isPDF: boolean;
  themeColor: string;
}) => {
  return (
    <TemplateThreePDFSectionWithSubsections heading={heading}>
      {projects.map(
        ({ project, startDate, endDate, descriptions, projectLink }, idx) => (
          <View
            key={idx}
            style={{ 
              ...styles.flexRow, 
              gap: "9pt", // Optimized spacing
              ...(idx !== 0 ? { marginTop: "9pt" } : {})
            }}
            wrap={false} // Prevent individual project items from splitting
          >
            <View style={{ width: "21%", marginTop: spacing["0.5"] }}>
              <ResumePDFText>
                {startDate && endDate
                  ? `${startDate} - ${endDate}`
                  : startDate || endDate}
              </ResumePDFText>
            </View>
            <View style={{ width: "79%", marginTop: spacing["0.5"] }}>
              <View
                style={{
                  marginTop: spacing["0.5"],
                }}
              >
                <View
                  style={{
                    ...styles.flexRow,
                    gap: spacing["2"],
                  }}
                >
                  <ResumePDFText bold={true}>{project}</ResumePDFText>
                  {projectLink && (
                    <ProjectPDFLink src={projectLink}>
                      <ResumePDFIcon
                        type="url"
                        isPDF={isPDF}
                        themeColor={themeColor}
                      />
                    </ProjectPDFLink>
                  )}
                </View>
              </View>
              <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
                <ResumePDFDescription items={descriptions} />
              </View>
            </View>
          </View>
        )
      )}
    </TemplateThreePDFSectionWithSubsections>
  );
};
